import { render } from "./ClaimsInstructionsApproved.vue?vue&type=template&id=08064ecf&ts=true"
import script from "./ClaimsInstructionsApproved.vue?vue&type=script&lang=ts"
export * from "./ClaimsInstructionsApproved.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__